import Router from './routes';
import ThemeConfig from './theme';
import ReqstInterceptor from './utils/ReqstInterceptor'; 
import { useIdleTimer } from 'react-idle-timer'
import toast from 'react-hot-toast';
import { CubeProvider } from '@cubejs-client/react';
import { url } from './config/urls';
import cubejs from '@cubejs-client/core';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { breadcrumbActions } from './redux/reducers/breadcrumb';
const App = () => {
  ReqstInterceptor()
  const onIdle = () => { 
    let accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      toast('Session Expired, Reload the page!', { duration: Infinity, icon: '⚠️' });
      localStorage.removeItem('accessToken')
    }
  }

  let cubeToken = localStorage.getItem('cubeToken')
  const cubejsApi = useMemo(() => {
    if (cubeToken) {
        return cubejs(cubeToken, { apiUrl: `${url.cubeApiUrl}/cubejs-api/v1` })
    } else {
        return ""
    }
  },[cubeToken])

  const { } = useIdleTimer({
    onIdle,
    timeout: 120 * 60 * 1000, //120 mins
    promptTimeout: 0,
    events: [
      'mousemove',
      'keydown',
      'wheel',
      'DOMMouseScroll',
      'mousewheel',
      'mousedown',
      'touchstart',
      'touchmove',
      'MSPointerDown',
      'MSPointerMove',
      'visibilitychange'
    ],
    immediateEvents: [],
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    element: document,
    startOnMount: true,
    startManually: false,
    stopOnIdle: false,
    crossTab: false,
    syncTimers: 0
  })

  return (
    <ThemeConfig className="ext">
      <CubeProvider cubejsApi={cubejsApi}>
        <Router />
      </CubeProvider>      
    </ThemeConfig>
  );
}

export default App
